import {
  ADD_HISTORY,
  DATA_FETCHING,
  RESET_HISTORY,
  SET_DATA_TYPE,
  SET_FETCHING_ERROR,
  UPDATE_HISTORY
} from '../constants';
import { Action, HistoryDataPayload } from '../types';

export const initialHistoryData = {
  data: [],
  totalPages: 0,
  page: 0,
  dataType: null,
  isFetching: false,
  isFetchingError: false
};

export const historyReducer = (
  state: HistoryDataPayload,
  action: Action
): HistoryDataPayload => {
  const { type, payload } = action;

  switch (type) {
    case DATA_FETCHING:
      return { ...state, ...payload };

    case SET_FETCHING_ERROR:
      return { ...state, ...payload };

    case SET_DATA_TYPE:
      return { ...state, ...payload };

    case ADD_HISTORY:
      return { ...state, ...payload };

    case RESET_HISTORY:
      return initialHistoryData;

    case UPDATE_HISTORY:
      return {
        ...state,
        ...payload,
        data: [
          ...(state.data as unknown[]),
          ...((payload as HistoryDataPayload).data as unknown[])
        ]
      };

    default:
      return state;
  }
};
